import React from 'react';
import { ContentItem, Heading } from './NewFooter.types';
import { FOOTER_DATA } from '../../constants/SEOConstants';

const getFooterItem = (heading: Heading) => {
  const footerContent = Object.keys(heading).map((content) => {
    return (
      <div className="LTSPageCommon-NewFooter-items-container" key={heading[content]}>
        {heading[content].map((item: ContentItem) => (
          <span className="LTSPageCommon-NewFooter-item" key={item.id}>
            <a href={item.onClickUrl} className="LTSPageCommon-NewFooter-link" key={item.id}>
              {item.text}
            </a>
          </span>
        ))}
      </div>
    );
  });

  return footerContent;
};

const NewFooter = () => {
  return (
    <div className="LTSPageCommon-NewFooter-wrapper">
      <div className="LTSPageCommon-NewFooter-content">
        {Object.keys(FOOTER_DATA).map((heading) => (
          <div key={heading}>
            <p className="LTSPageCommon-NewFooter-heading">{heading}</p>
            {getFooterItem(FOOTER_DATA[heading])}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewFooter;
